<template>
    <div class="searchInput">
        <input
            id="searchInput-input"
            class="searchInput__input"
            type="text"
            :placeholder="placeholder"
            v-model.trim="searchParams.q"
            @keyup.enter="submit"
        />
        <svg class="searchInput__underline" :class="{'searchInput__underline--loading': isLoading }" width="100" height="1" viewBox="0 0 100 1" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" stroke="currentColor" stroke-width="2px">
            <line class="loading" x1="0" y1="0" x2="100" y2="0" />
            <line x1="0" y1="0" x2="100" y2="0" />
        </svg>
        <div class="searchInput__searchicon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
        </div>
        <div v-if="searchParams.q || hasAdvancedParameters" class="searchInput__clear" @click="clear">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </div>
        <div class="searchInput__advancedicon" :class="{'searchInput__advancedicon--active': hasAdvancedParameters}" @click="toggleAdvancedSearch">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-sliders"><line x1="4" y1="21" x2="4" y2="14"></line><line x1="4" y1="10" x2="4" y2="3"></line><line x1="12" y1="21" x2="12" y2="12"></line><line x1="12" y1="8" x2="12" y2="3"></line><line x1="20" y1="21" x2="20" y2="16"></line><line x1="20" y1="12" x2="20" y2="3"></line><line x1="1" y1="14" x2="7" y2="14"></line><line x1="9" y1="8" x2="15" y2="8"></line><line x1="17" y1="16" x2="23" y2="16"></line></svg>
        </div>

        <transition name="fade">
            <div v-if="showAdvancedSearch" class="searchInput__advanced">
                <div class="columns">
                    <div class="column">
                        <p>
                            <label class="label" for="searchSourceDomain">
                                Source Domain:
                                <input class="input" placeholder="strictly-business.com" type="text" name="searchSourceDomain" id="searchSourceDomain" v-model.trim="searchParams.sourceDomain" />
                            </label>
                        </p>
                    </div>
                </div>

                <div class="columns">
                    <div class="column is-half">
                        <p>
                            <label class="label" for="searchDateBefore">
                                Before:
                                <input class="input" type="date" name="searchDateBefore" id="searchDateBefore" v-model="searchParams.dateBefore" />
                            </label>
                        </p>
                    </div>

                    <div class="column is-half">
                        <p>
                            <label class="label" for="searchDateAfter">
                                After:
                                <input class="input" type="date" name="searchDateAfter" id="searchDateAfter" v-model="searchParams.dateAfter" />
                            </label>
                        </p>
                    </div>
                </div>

                <div class="columns">
                    <div class="column">
                        <button class="button is-primary" @click="submit">Refine my search</button>
                    </div>
                </div>
            </div>
        </transition>

    </div>
</template>

<script>
export default {
    name: 'search-input',
    props: {
        initialParams: {
            type: Object
        },
        placeholder: {
            type: String,
            default: 'search the library'
        },
        isLoading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            searchParams: {
                q: this.initialParams.q || '',
                dateBefore: this.initialParams.dateBefore || '',
                dateAfter: this.initialParams.dateAfter || '',
                sourceDomain: this.initialParams.sourceDomain || ''
            },
            showAdvancedSearch: false
        };
    },
    methods: {
        toggleAdvancedSearch() {
            this.showAdvancedSearch = !this.showAdvancedSearch;
        },

        submit(e) {
            this.showAdvancedSearch = false;
            this.$emit('search', this.searchParams);
        },

        clear(e) {
            this.searchParams.q = '';
            this.searchParams.sourceDomain = '';
            this.searchParams.dateBefore = '';
            this.searchParams.dateAfter = '';
            this.showAdvancedSearch = false;
            this.$emit('searchCleared');
        }
    },
    computed: {
        hasAdvancedParameters: function() {
            return (this.searchParams.sourceDomain || this.searchParams.dateBefore || this.searchParams.dateAfter);
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/SearchInput.vue